import React, { useState, useEffect } from 'react'
import CartIcon from './CartIcon'
import { useCartState } from '@/contexts/CartContext'
import { motion, AnimatePresence } from 'framer-motion'
import CartModal from './CartModal'
import { useRouter } from 'next/router'
import { useCTAContext } from '@/contexts/CTAContext'
import { useTranslation } from 'next-i18next'

type Props = {}

const FloatingCartButton = (props: Props) => {
  const {t} = useTranslation('cart');
  const {locale} = useRouter();
  const cart = useCartState()
  const cartItemsCount = cart.items.length
  const [isCartModalOpen, setIsCartModalOpen] = useState(false)
  const router = useRouter()
  const { isCTAVisible } = useCTAContext()

  // Close cart modal when URL changes
  useEffect(() => {
    setIsCartModalOpen(false)
  }, [router.asPath])

  // Hide the cart button on certain pages
  const hiddenRoutes = ['/cart', '/address', '/payment']
  const isHidden = hiddenRoutes.some((route) => router.asPath.includes(route))
  const isProductPage = router.asPath.includes('/product')
  const isProductsPage = router.asPath.includes('/products')

  // Animation variants
  const variants = {
    hidden: { x: -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
        x: {
          repeat: 1,
          repeatType: 'mirror',
          duration: 0.1,
          delay: 0.2,
          keyframes: [0, -6, 6, -2, 2, 0]
        }
      }
    },
    exit: { x: -100, opacity: 0, transition: { duration: 0.2 } }
  }

  if (isHidden) return null

  return (
    <>
      <AnimatePresence>
        {cartItemsCount > 0 && (
          <motion.div
            className={`fixed ${isCTAVisible && isProductPage && !isProductsPage ? 'bottom-32' : 'bottom-0'} left-0 m-4 z-50 md:hidden`}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={variants}
          >
            <div
              className="bg-primary rounded-3xl shadow-lg px-5 py-3 flex items-center gap-2 relative"
              dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
              onClick={() => setIsCartModalOpen(true)}
            >
              <p className={`bg-emerald-400 text-primary w-[18px] h-[18px] p-2 flex items-center justify-center text-sm font-semibold text-center rounded-full absolute ${locale === 'ar'? 'right-[6px]': 'left-[6px]'} top-[5px] z-10`}>
                <span>{cartItemsCount}</span>
              </p>
              <CartIcon color="#fff" />
              <p className="text-base text-white">{t('floatingCartButtonText')}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <CartModal isOpen={isCartModalOpen} onClose={() => setIsCartModalOpen(false)} />
    </>
  )
}

export default FloatingCartButton
